import { Helmet } from 'react-helmet-async';

interface Props {
  title: string;
  description?: string;
  noIndex?: boolean;
  noReferrer?: boolean;
}

export default function PageHead({
  title,
  description = 'Premium intercity bus booking in Bangladesh — Star Line Group',
  noIndex = false,
  noReferrer = false,
}: Props) {
  return (
    <Helmet>
      <title>{title} | Star Line Group</title>
      <meta name="description" content={description} />
      {noIndex && <meta name="robots" content="noindex, nofollow, noarchive" />}
      {noReferrer && <meta name="referrer" content="no-referrer" />}
    </Helmet>
  );
}
